<!--
 * @Author: caiyuliu
 * @Date: 2025-12-15 09:46:13
 * @LastEditors: caiyuliu
 * @LastEditTime: 2025-12-15 10:04:22
 * @Description: 搜索和筛选组件
-->
<template>
  <div class="search-filter">
    <div class="search-box">
      <span class="search-icon">🔍</span>
      <input v-model="searchQuery" type="text" placeholder="搜索产品或协议..." @input="handleSearch" />
      <button v-if="searchQuery" class="clear-btn" @click="clearSearch">✕</button>
    </div>

    <div class="filter-group">
      <div class="filter-item">
        <label>协议类型：</label>
        <select v-model="selectedType" @change="handleFilter">
          <option value="">全部</option>
          <option value="disclaimer">免责声明</option>
          <option value="privacy">隐私政策</option>
          <option value="userAgreement">用户协议</option>
          <option value="organize">组织认证</option>
          <option value="other">其他</option>
        </select>
      </div>

      <div class="filter-item">
        <label>语言：</label>
        <select v-model="selectedLanguage" @change="handleFilter">
          <option value="">全部</option>
          <option value="zh-CN">简体中文</option>
          <option value="en-US">英语</option>
          <option value="ja-JP">日语</option>
          <option value="ko-KR">韩语</option>
          <option value="ar-SA">阿拉伯语</option>
          <option value="es-ES">西班牙语</option>
          <option value="fr-FR">法语</option>
          <option value="hi-IN">印地语</option>
          <option value="id-ID">印尼语</option>
          <option value="ms-MY">马来语</option>
          <option value="ru-RU">俄语</option>
          <option value="th-TH">泰语</option>
          <option value="vi-VN">越南语</option>
          <option value="bn-BD">孟加拉语</option>
        </select>
      </div>

      <button class="reset-btn" @click="resetFilters">重置筛选</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchFilter',
  data() {
    return {
      searchQuery: '',
      selectedType: '',
      selectedLanguage: ''
    }
  },
  methods: {
    handleSearch() {
      this.emitFilters()
    },
    handleFilter() {
      this.emitFilters()
    },
    clearSearch() {
      this.searchQuery = ''
      this.emitFilters()
    },
    resetFilters() {
      this.searchQuery = ''
      this.selectedType = ''
      this.selectedLanguage = ''
      this.emitFilters()
    },
    emitFilters() {
      this.$emit('filter-change', {
        search: this.searchQuery,
        type: this.selectedType,
        language: this.selectedLanguage
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-filter {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;

  .search-box {
    position: relative;
    margin-bottom: 16px;

    .search-icon {
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 18px;
    }

    input {
      width: 100%;
      padding: 12px 48px 12px 48px;
      border: 2px solid #e0e0e0;
      border-radius: 8px;
      font-size: 14px;
      transition: all 0.3s ease;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: #4caf50;
        box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
      }

      &::placeholder {
        color: #999;
      }
    }

    .clear-btn {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      background: #e0e0e0;
      border: none;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      cursor: pointer;
      font-size: 14px;
      color: #666;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      &:hover {
        background: #d0d0d0;
      }
    }
  }

  .filter-group {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;

    .filter-item {
      display: flex;
      align-items: center;
      gap: 8px;

      label {
        font-size: 14px;
        color: #666;
        white-space: nowrap;
      }

      select {
        padding: 8px 32px 8px 12px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        font-size: 14px;
        background: #fff;
        cursor: pointer;
        transition: all 0.3s ease;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;

        &:focus {
          outline: none;
          border-color: #4caf50;
          box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
        }
      }
    }

    .reset-btn {
      padding: 8px 16px;
      background: #f5f5f5;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      transition: all 0.2s ease;
      margin-left: auto;

      &:hover {
        background: #e0e0e0;
      }
    }
  }
}

@media (max-width: 768px) {
  .search-filter {
    padding: 16px;

    .filter-group {
      flex-direction: column;
      align-items: stretch;

      .filter-item {
        width: 100%;

        label {
          min-width: 80px;
        }

        select {
          flex: 1;
        }
      }

      .reset-btn {
        margin-left: 0;
        width: 100%;
      }
    }
  }
}
</style>
